// import axios from "axios";
// import accessToken from "./jwt-token-access/accessToken"

//pass new generated access token here
// const token = accessToken
import * as Utils from "../Utils";
import { inspectAdminResponse, isLegacyNotAuthorizedMessage } from "./admin_api";
// apply base url for axios
// const API_URL = "https://mehandipurbalaji.app";
const API_URL = Utils.API_URL;

// Helper function to get admin token
const getAuthToken = () => {
  return localStorage.getItem("adminToken");
};

async function parseJsonWithAdminGuards(response) {
  const data = await response.json();
  if (inspectAdminResponse(response, data)) {
    const forbidden =
      response.status === 403 || isLegacyNotAuthorizedMessage(data?.message);
    const error = new Error(
      forbidden ? "Not authorized" : "Session expired. Please sign in again."
    );
    error.status = forbidden ? 403 : 401;
    error.response = data;
    throw error;
  }
  return data;
}

// const axiosApi = axios.create({
//   baseURL: API_URL,
// })

// axiosApi.defaults.headers.common["Authorization"] = token

// axiosApi.interceptors.response.use(
//   response => response,
//   error => Promise.reject(error)
// )

export async function get(url, params = {}) {
  // Extract token from params if passed, otherwise use default
  const token = params.token || getAuthToken();
  const tokenHeader = token ? `Bearer ${token}` : "";

  // Remove token from params for building query string
  const queryParams = { ...params };
  delete queryParams.token;

  // Build query string from params object
  const queryString = new URLSearchParams();
  Object.keys(queryParams).forEach(key => {
    if (queryParams[key] !== undefined && queryParams[key] !== null) {
      queryString.append(key, queryParams[key]);
    }
  });

  const queryPart = queryString.toString() ? `?${queryString.toString()}` : "";
  const fullUrl = API_URL + url + queryPart;

  return fetch(fullUrl, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      "Authorization": tokenHeader
    },
  })
    .then((res) => parseJsonWithAdminGuards(res))
    .catch(error => {
      console.error('Fetch error:', error);
      throw error;
    });

}

export async function download(url, data) {
  const token = data?.token || getAuthToken();
  // return await axiosApi.get(url, { ...config }).then(response => response.data)
  return fetch(API_URL + url, {
    method: 'GET',
    headers: {
      // mode: 'no-cors',
      Accept: 'application/zip',
      'Content-Type': 'application/json',
      "Authorization": token ? `Bearer ${token}` : ""
    },
    // body: JSON.stringify(data)
  }).then(res => res.blob())

}

/**
 * Authenticated file download (PDF/CSV) with Bearer token.
 * Parses Content-Disposition when present; throws with API message on JSON errors.
 */
export async function downloadFile(url, options = {}) {
  const token = options.token || getAuthToken();
  const accept = options.accept || 'application/pdf,text/csv,application/octet-stream,*/*';
  const response = await fetch(API_URL + url, {
    method: 'GET',
    headers: {
      Accept: accept,
      Authorization: token ? `Bearer ${token}` : '',
    },
  });

  const contentType = response.headers.get('content-type') || '';
  if (!response.ok || contentType.includes('application/json')) {
    let message = `Download failed (${response.status})`;
    try {
      const err = await response.json();
      if (inspectAdminResponse(response, err)) {
        const forbidden =
          response.status === 403 || isLegacyNotAuthorizedMessage(err?.message);
        const error = new Error(forbidden ? "Not authorized" : "Session expired. Please sign in again.");
        error.status = forbidden ? 403 : 401;
        throw error;
      }
      if (err?.message) message = err.message;
    } catch (parseError) {
      if (parseError?.status === 401 || parseError?.status === 403) {
        throw parseError;
      }
      /* ignore other parse errors */
    }
    throw new Error(message);
  }

  const blob = await response.blob();
  const disposition = response.headers.get('content-disposition') || '';
  const match = disposition.match(/filename\*?=(?:UTF-8''|")?([^";]+)"?/i);
  const rawName = match ? decodeURIComponent(match[1].replace(/["']/g, '')) : null;
  const filename = options.filename || rawName || 'download';

  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = objectUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(objectUrl);

  return { filename, blob };
}

export async function post(url, data) {
  const token = data?.token || getAuthToken();
  return fetch(API_URL + url, {
    method: 'POST',
    headers: {
      // mode: 'no-cors',
      Accept: 'application/json',
      'Content-Type': 'application/json',
      "Authorization": token ? `Bearer ${token}` : ""
    },
    body: JSON.stringify(data)
  }).then((res) => parseJsonWithAdminGuards(res))
  // .post(API_URL+url, { ...data }, { ...config })
  // .then(response => response.data)
}

export async function put(url, data) {
  const token = data?.token || getAuthToken();
  return fetch(API_URL + url, {
    method: 'PUT',
    headers: {
      // mode: 'no-cors',
      Accept: 'application/json',
      'Content-Type': 'application/json',
      "Authorization": token ? `Bearer ${token}` : ""
    },
    body: JSON.stringify(data)
  }).then((res) => parseJsonWithAdminGuards(res))
}

export async function upload(url, data, token) {
  const authToken = token || getAuthToken();

  const headers = {};
  if (authToken) {
    headers['Authorization'] = `Bearer ${authToken}`;
  }

  return fetch(API_URL + url, {
    method: 'POST',
    headers: headers,
    // mode: 'no-cors',
    // headers: {
    //   mode: 'no-cors',
    //   "Content-Type": "multipart/form-data",
    // "Accept": "application/json",
    //   "type": "formData",
    //   "Authorization": "Bareer " + token
    // },
    body: data
  }).then((res) => parseJsonWithAdminGuards(res))
}

export async function patch(url, data) {
  const token = data?.token || getAuthToken();
  return fetch(API_URL + url, {
    method: 'PATCH',
    headers: {
      // mode: 'no-cors',
      Accept: 'application/json',
      'Content-Type': 'application/json',
      "Authorization": token ? `Bearer ${token}` : ""
    },
    body: JSON.stringify(data)
  }).then((res) => parseJsonWithAdminGuards(res))
}

export async function del(url, data) {
  const token = data?.token || getAuthToken();
  return fetch(API_URL + url, {
    method: 'DELETE',
    headers: {
      // mode: 'no-cors',
      Accept: 'application/json',
      'Content-Type': 'application/json',
      "Authorization": token ? `Bearer ${token}` : ""
    },
    body: JSON.stringify(data)
  }).then((res) => parseJsonWithAdminGuards(res))
}
